import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice ({
    name: 'auth',
    initialState: true,
    reducers: {
        toogleAuth:(state) => !state
    }
})

export const {toogleAuth} = authSlice.actions
export default authSlice.reducer